<!--
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-10-27 13:47:13
-->
<template>
	<div>
		<el-cascader
			:model-value="roomData"
			@update:model-value="handleChange"
			:options="options"
			:placeholder="$t('system.choice')"
			:props="propsmultiple"
			:collapse-tags="true"
			clearable
		/>
	</div>
</template>

<script>
import {
	reactive,
	toRefs,
	onMounted
} from "vue";
import { regionAndRoomList } from '@/apis/region'
export default {
	props: ["roomData"],
	setup(props, context) {
		const state = reactive({
			propsmultiple: { multiple: true },
			options: [],
			getData() {
				regionAndRoomList().then((res => {
					if (res.code == 200) {
						const list = res.data, arr = []
						list.map((item, index) => {
							const obj = {
								label: item.area_name,
								value: item.ID,
								children: []
							}
							arr.push(obj)
							const data = item.room_list
							if (data && data.length > 0) {
								data.map(li => {
									const _obj = {
										label: li.RoomName,
										value: li.ID,
									}
									arr[index].children.push(_obj)
								})
							} else {
								arr[index].disabled = true
							}
						})
						state.options = arr
					}
				}))
			},
			handleChange(value) {
				context.emit("getRoomData", value);
			}
		});
		onMounted(() => {
			state.getData()
		});
		return {
			...toRefs(state)
		};
	}
};
</script>

<style lang="scss" scoped></style>
